import * as React from 'react';
import styled from 'styled-components';
import { HashHintItem } from './HashHintItem';
import { ListWithSelection } from './ListWithSelection';
const List = (props) => {
    const { className, focusedIndex, width, onPrev } = props;
    const items = props.items.map((item, index) => {
        const focused = focusedIndex === index;
        const onClick = () => {
            props.onSelect(item, index);
        };
        const onEnter = () => {
            props.onFocus(index);
        };
        return (React.createElement(HashHintItem, Object.assign({}, item, { key: index, focused: focused, width: width, onClick: onClick, onEnter: onEnter, onPrev: onPrev })));
    });
    return React.createElement("ul", { className: className }, items);
};
const StyledList = styled(List) `
  list-style: none;
  margin: 0;
  padding: 0;
`;
export const HashHintList = ListWithSelection(StyledList);
//# sourceMappingURL=HashHintList.js.map